import React from "react";
import { DivPromocoes } from './style';
import Megafone from '../img/MegaFone.png'

export const Promocoes = () => {

    return (
        <DivPromocoes>

            <div className="conteudo">

                <div className="coluna-esquerda">
                    <h1>PROMOÇÕES</h1>
                    <p>Confira nossas promoções<br />relâmpago, por tempo limitado!</p>
                    <a href="#fale-conosco" className="botao">Entre em Contato &gt;&gt;</a>
                </div>

                <div className="coluna-direita">
                    <img src={Megafone} alt="Megafone anunciando promoções" />
                </div>

                <div className="linha-final">
                    <span className="quadrado"></span>
                </div>

            </div>

        </DivPromocoes>
    )
}
